/** Stable color from a label, indexed into the given palette. */
const colorForLabel = (name, palette) => {
  const label = String(name || '');
  const size = palette?.length || 0;
  if (!size) return undefined;
  let hash = 0;
  for (let i = 0; i < label.length; i += 1) {
    hash = ((hash * 31) + label.codePointAt(i)) % size;
  }
  return palette[Math.abs(hash) % size];
};

export default colorForLabel;
